export const sanitizeURL = (URL: string) => {
  const noSpaceToolName = URL.replace(/ /g, '');
  const sanitizedToolName = noSpaceToolName.replace(/[^\x20-\x7E]/g, ''); // Remove non-printable characters
  const encodedToolName = encodeURIComponent(sanitizedToolName);
  return encodedToolName;
};
